import * as pdfjsLib from 'pdfjs-dist';
import { uploadFileToS3 } from '../../utils/s3Operations';

pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';

export async function uploadFile(file) {
  if (file.type === 'application/pdf') {
    // 1) Convert PDF to PNG blob
    const pngBlob = await convertPdfToPng(file);

    // 2) Turn that blob into a File with a unique name
    const uniqueName = `pdf-preview-${Date.now()}.png`;
    const pngFile = new File([pngBlob], uniqueName, { type: 'image/png' });

    // 3) Upload the file to S3
    const url = await uploadFileToS3(pngFile, pngFile.type);

    return { url, fileType: 'image' };
  } else if (file.type.startsWith('image/')) {
    // ...
    const url = await uploadFileToS3(file, file.type);
    return { url, fileType: 'image' };
  } else if (file.type.startsWith('video/')) {
    // ...
    const url = await uploadFileToS3(file, file.type);
    return { url, fileType: 'video' };
  } else {
    throw new Error('Unsupported file type: ' + file.type);
  }
}

async function convertPdfToPng(pdfFile) {
  const pdfData = await pdfFile.arrayBuffer();
  const pdfDoc = await pdfjsLib.getDocument({ data: pdfData }).promise;
  const page = await pdfDoc.getPage(1);

  const scale = 1;
  const viewport = page.getViewport({ scale });
  const canvas = document.createElement('canvas');
  canvas.width = viewport.width;
  canvas.height = viewport.height;
  const context = canvas.getContext('2d');

  const renderTask = page.render({ canvasContext: context, viewport });
  await renderTask.promise;

  // Canvas to dataURL -> fetch -> blob
  const dataUrl = canvas.toDataURL('image/png');
  const response = await fetch(dataUrl);
  const blob = await response.blob();
  return blob;
}
